import domtoimage from "dom-to-image";

const STYLE_KEYS = [
  "overflow",
  "overflowX",
  "overflowY",
  "height",
  "maxHeight",
  "minHeight",
  "flex",
  "paddingBottom",
];

const DATA_CELL_SELECTOR =
  "td.amountCell, td.totalCell, td.categoryTotal, td.subTotal.incomeOutcomeMoneyRow, td.incomeOutcomeMoneyRow";

function saveStyles(el) {
  const saved = {};
  STYLE_KEYS.forEach((key) => {
    saved[key] = el.style[key];
  });
  return saved;
}

function restoreStyles(el, saved) {
  STYLE_KEYS.forEach((key) => {
    el.style[key] = saved[key] || "";
  });
}

function measureTableContentHeight(table) {
  if (!table) return 0;
  let height = 0;
  table.querySelectorAll("thead tr, tbody tr").forEach((row) => {
    if (row.style.display === "none") return;
    height += row.offsetHeight;
  });
  return Math.ceil(height);
}

function waitForLayout() {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(resolve, 80);
      });
    });
  });
}

/** Oculta filas sin celdas de monto (artefactos de filas colapsadas en DOM). */
function hideEmptyDataRows(wrapper) {
  const hidden = [];
  wrapper.querySelectorAll("tbody tr").forEach((row) => {
    if (row.querySelector("td.flowSectionHeaderCell")) return;
    const hasDataCell = row.querySelector(DATA_CELL_SELECTOR);
    if (!hasDataCell) {
      hidden.push({ row, display: row.style.display });
      row.style.display = "none";
    }
  });
  return hidden;
}

function restoreHiddenRows(hidden) {
  hidden.forEach(({ row, display }) => {
    row.style.display = display;
  });
}

export default async function captureFlowTableScreenshot(
  wrapper,
  filename = "flujo-caja.png",
  prepareApi
) {
  if (!wrapper) return;

  const scrollParent = wrapper.closest(".flowTableScroll");
  const table = wrapper.querySelector("table.flowTableFit");
  const targets = [scrollParent, wrapper].filter(Boolean);

  const savedStyles = targets.map((el) => ({
    el,
    styles: saveStyles(el),
  }));

  let savedExpansionState;
  let hiddenRows = [];

  const enableCaptureMode = () => {
    wrapper.classList.add("flow-screenshot-capture");
    scrollParent?.classList.add("flow-screenshot-capture");
    targets.forEach((el) => {
      el.style.overflow = "visible";
      el.style.overflowX = "visible";
      el.style.overflowY = "visible";
      el.style.height = "auto";
      el.style.maxHeight = "none";
      el.style.minHeight = "auto";
      el.style.flex = "none";
    });
  };

  const disableCaptureMode = () => {
    wrapper.classList.remove("flow-screenshot-capture");
    scrollParent?.classList.remove("flow-screenshot-capture");
    savedStyles.forEach(({ el, styles }) => restoreStyles(el, styles));
  };

  enableCaptureMode();

  try {
    if (prepareApi?.current?.prepare) {
      savedExpansionState = await prepareApi.current.prepare();
      await waitForLayout();
    } else {
      await waitForLayout();
    }

    hiddenRows = hideEmptyDataRows(wrapper);
    await waitForLayout();

    const contentWidth = Math.ceil(
      Math.max(wrapper.scrollWidth, table?.scrollWidth || 0, table?.offsetWidth || 0)
    );
    const contentHeight =
      Math.ceil(
        Math.max(
          measureTableContentHeight(table),
          wrapper.scrollHeight,
          table?.scrollHeight || 0
        )
      ) + 16;

    const dataUrl = await domtoimage.toPng(wrapper, {
      bgcolor: "#ffffff",
      width: contentWidth,
      height: contentHeight,
      style: {
        overflow: "visible",
        height: `${contentHeight}px`,
        width: `${contentWidth}px`,
        backgroundColor: "#ffffff",
      },
    });

    const link = document.createElement("a");
    link.download = filename;
    link.href = dataUrl;
    link.click();
  } catch (err) {
    console.error("Error al capturar pantallazo:", err);
  } finally {
    restoreHiddenRows(hiddenRows);
    if (savedExpansionState !== undefined && prepareApi?.current?.restore) {
      prepareApi.current.restore(savedExpansionState);
    }
    disableCaptureMode();
  }
}
